/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import GridItem from '../../components/Grid/GridItem';
import CustomInputExt from '../../components/CustomInput/CustomInputExt';
import { Card, CardHeader, Checkbox, FormControlLabel } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import CardBody from '../../components/Card/CardBody';
import MvnoOperationSetup from '../../interfaces/platform/MvnoOperatorSetup';
import CustomInputExtNumber from '../../components/CustomInput/CustomInputExtNumber';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { ServiceProfileCustomFeaturesList } from './ServiceProfileCustomFeaturesList';

const _ = require('underscore');

type ServiceProfileEditType = {
    handleSetBrandText: (text: string) => void;
};

export type ServiceTemplateItems = {
    components: Array<{ [key: string]: { verb: string; param: Array<{ name: string; value: string | number }> } }>;
    promotions?: Array<{ value: number; name: string }> | null;
};

export const ServiceProfileEdit: FunctionComponent<ServiceProfileEditType> = ({ handleSetBrandText }): ReactElement => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [displayName, setDisplayName] = useState('');
    const [prepaid, setPrepaid] = useState(false);
    const [constName, setConstName] = useState('');
    const [constValue, setConstValue] = useState('');
    const [mvnoOperatorSetup, setMvnoOperatorSetup] = useState<MvnoOperationSetup | null>(null);

    useEffect(() => {
        if (mvnoOperatorSetup === null) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getWithCallback(
                FormGeneralHelper.getByUri('/' + id),
                'mvno_operator_setup_edit_item',
                (data: MvnoOperationSetup) => {
                    setDisplayName(data.displayName);
                    setPrepaid(data.prepaid);
                    setConstValue(data.constValue);
                    setConstName(data.constName);
                    setMvnoOperatorSetup(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        }
    }, [dispatch, id, mvnoOperatorSetup]);

    const saveCallback = (): void => {};

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'displayName':
                setDisplayName(value);
                break;
            case 'constName':
                setConstName(value);
                break;
            case 'constValue':
                setConstValue(value);
                break;
            default:
                return;
        }
    };

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const checked = event.target.checked;
        const value = event.target.value;
        setPrepaid(checked);
    };

    return (
        <GridContainer>
            <GridItem xs={6}>
                <Card>
                    <CardHeader title={<I18n trans="prov:profile.edit_profile" />} />
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12}>
                                <CustomInputExt
                                    formControlProps={{ fullWidth: true }}
                                    required={true}
                                    labelText="prov:profile.name"
                                    name="displayName"
                                    value={displayName}
                                    onChange={onChangeEvent}
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <CustomInputExt
                                    formControlProps={{ fullWidth: true }}
                                    required={true}
                                    labelText="prov:profile.id_profile_string"
                                    name="constName"
                                    value={constName}
                                    onChange={onChangeEvent}
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <CustomInputExtNumber
                                    formControlProps={{ fullWidth: true }}
                                    required={true}
                                    labelText="prov:profile.id_profile_number"
                                    name="constValue"
                                    value={constValue}
                                    onChange={onChangeEvent}
                                />
                            </GridItem>
                            <GridItem xs={6}>
                                <FormControlLabel
                                    control={<Checkbox checked={prepaid} name="prepaid" onChange={onCheckBoxEvent} value={1} />}
                                    label={<I18n trans="prov:profile.is_prepaid" />}
                                />
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12}>
                                <CustomTextButtom callback={saveCallback} callbackParam={{}} label="general:common.save" size="sm" />
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem style={{ marginTop: '10px' }} xs={12}>
                {mvnoOperatorSetup && <ServiceProfileCustomFeaturesList mvnoOperatorSetup={mvnoOperatorSetup} />}
            </GridItem>
        </GridContainer>
    );
};
